import Vue from 'vue'
import Router from 'vue-router'
import primary from '@/components/primary'
import gamePeterPan from '@/components/rides/peterPan/game'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: primary
    },
    {
      path: '/peter',
      name: 'Peter Pan',
      component: gamePeterPan
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js